import React, { useState, useEffect } from 'react'

// import LazyLoad from 'react-lazy-load'
import { useSelector, shallowEqual } from 'react-redux'
import { Redirect } from 'react-router-dom'
import styled from 'styled-components'

import { SimpleCarousel } from '.'
import { BreadCrumbs } from '..'
import { useWindowSize } from '../../_helpers'
import {
    Container,
    Meta,
    devices,
    // colors,
} from '../Common'
import { Loading } from '../Global/Loading'

const ImageCard = ({ image, openModal }) => (
    <GalleryImage src={image.image} alt={image.alt_text} onClick={openModal} />
)


const PageView = () => {
    const { page, notFound } = useSelector(state => state.content, shallowEqual)
    const { gallery, title } = page

    const [showLightBox, setShowLightBox] = useState(false)
    const [activeSlide, setactiveSlide] = useState(0)
    const { width } = useWindowSize()
    const mobile = width < 480


    if (notFound) return <Redirect to='/' />

    const openModal = i => {
        setactiveSlide(i)
        window.scrollTo(0, 0)
        setShowLightBox(true)
    }

    const closeModal = () => setShowLightBox(false)

    useEffect(closeModal, [page])

    return (
        <>
            <Meta page={page} />
            <PageContainer lightbox={showLightBox}>
                {gallery ?
                    showLightBox ?
                        <SimpleCarousel slides={gallery} close={closeModal} activeImage={activeSlide} title={title} mobile={mobile} />
                        :
                        <>
                            {title && <BreadCrumbs title={title} mobile={mobile} />}
                            <ImageList>
                                {gallery.map((image, i) => <ImageCard key={i} image={image} openModal={() => openModal(i)} />)}
                            </ImageList>
                        </>
                    : <Loading marginbottom={30} />}
            </PageContainer>
        </>
    )
}

const PageContainer = styled(Container)`
    ${({ lightbox }) => lightbox && `
        padding-left: 0;
        padding-right: 0;
    `}

    min-height: calc(100vh - 90px);
    @media ${devices.small} {
        min-height: 95vh;
    }
`

const ImageList = styled.div`
   column-count: 3;
   column-gap: 6px;

    @media ${devices.small} {
        column-count: 2;
        column-gap: 6px;
    }
`

const GalleryImage = styled.img`
    width: calc(100% - 18px);
    height: auto;
    border: 7px solid white;
    cursor: pointer;
    margin-bottom: 6px;

    @media ${devices.small} {
        border-width: 3px;
        width: 96%;
    }
`

export default PageView
